// relativeTime(date) -> "just now" / "5 min ago" / "2 h ago" / "3 d ago"
// or an absolute date string past a week. Same formatter the dashboard
// uses, extracted so the wizard's save-state indicator can stay in sync.
export function relativeTime(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const now = Date.now();
  const sec = (now - d.getTime()) / 1000;
  if (sec < 60) return 'just now';
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} h ago`;
  if (sec < 7 * 86400) return `${Math.floor(sec / 86400)} d ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
